import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { defaultSYS3050_R01Dto, SYS3050_R01Dto } from 'src/containers/mes/SYS/SYS3050_R01/Dto_SYS3050_R01';
import { create } from 'zustand';


export interface SYS3050_R01Filter {
	compCd: string;
	orgCd: string;
	empSts: string;
	date: Date | undefined;
}

const defalutDateRange = {
	from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
	to: new Date()
}

export interface Store_SYS3050_R01 {

	defalutDateRange: DateRange;

	//검색 폼 관련
	SYS3050_R01Filter: SYS3050_R01Filter;
	SYS3050_R01PastFilter: SYS3050_R01Filter;
	setSYS3050_R01Filter: (filter: Partial<SYS3050_R01Filter>) => void;	
	setSYS3050_R01PastFilter: (filter: Partial<SYS3050_R01Filter>) => void;

	// === 지정 관련 ===
	selectedSYS3050_R01: SYS3050_R01Dto | undefined;
	setSelectedSYS3050_R01: (data: SYS3050_R01Dto | undefined) => void;
	initSelectedSYS3050_R01: () => void;

	// info 폼 관련
	editSYS3050_R01: SYS3050_R01Dto | undefined;
	setEditSYS3050_R01: (data: SYS3050_R01Dto | undefined) => void;

	// === 리스트 관련 ===
	SYS3050_R01List: SYS3050_R01Dto[];	
	setSYS3050_R01List: (SYS3050_R01List: SYS3050_R01Dto[]) => void;
	insertSYS3050_R01List: (data: SYS3050_R01Dto[], index: number) => void;
	removeSYS3050_R01List: (empNo: string) => void;
	updateSYS3050_R01List: (data: SYS3050_R01Dto, index: number) => void;
	
	//그리드 컬럼 구성 순서 상태 지정정
	columnState: ColumnState[] | null;		setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;						setAllCount: (allCount: number) => void;
	

	// 초기화화
	initData: () => void;	

}

export const defaultSYS3050_R01Filter : SYS3050_R01Filter = {

	compCd: '',
	orgCd: '',
	empSts: '',
	date: new Date(),
}

export const useSYS3050_R01Store = create<Store_SYS3050_R01>((set) => ({

	defalutDateRange: defalutDateRange,

	SYS3050_R01Filter: defaultSYS3050_R01Filter,
	SYS3050_R01PastFilter: defaultSYS3050_R01Filter,
	setSYS3050_R01Filter: (options: Partial<SYS3050_R01Filter>) => set((state) => ({ SYS3050_R01Filter: { ...state.SYS3050_R01Filter, ...options } })),
	setSYS3050_R01PastFilter: (options: Partial<SYS3050_R01Filter>) => set((state) => ({ SYS3050_R01PastFilter: { ...state.SYS3050_R01PastFilter, ...options } })),

	selectedSYS3050_R01: undefined,
	//grid 행을 클릭하면 해당 행의 데이터를 editSYS3050_R01에 저장하기 위해서 다음과 같이 구성
	setSelectedSYS3050_R01: (data: SYS3050_R01Dto | undefined) => set((state) => {

		return { ...state, selectedSYS3050_R01: data };
	}),
	initSelectedSYS3050_R01: () => set({ selectedSYS3050_R01: undefined, editSYS3050_R01: undefined }),
	
	//setEdit 관련 함수는 가능한한 info 폼에서만 사용할수 있게 한다.
	editSYS3050_R01: defaultSYS3050_R01Dto,	
	setEditSYS3050_R01: (data: SYS3050_R01Dto | undefined) => set((state) => {
		// console.log(data);
		let editSYS3050_R01 = defaultSYS3050_R01Dto;
		if (data) {
			editSYS3050_R01 = {
				...data
			}
		}
		return { ...state, editSYS3050_R01: editSYS3050_R01 };
	}),

	SYS3050_R01List: [],	
	setSYS3050_R01List: (SYS3050_R01List: SYS3050_R01Dto[]) => set((state) => ({
		...state,
		SYS3050_R01List: SYS3050_R01List,
	})),

	//그리드 추가작업예정 지정
	insertSYS3050_R01List: (data: SYS3050_R01Dto[], index: number) => set((state) => {
		const _SYS3050_R01List = [...state.SYS3050_R01List];
		_SYS3050_R01List.splice(index, 0, ...data);
		return { ...state, SYS3050_R01List: _SYS3050_R01List };
	}),

	//그리드 수정작업예정 지정
	updateSYS3050_R01List: (data: SYS3050_R01Dto, index: number) => set((state) => {
		const _SYS3050_R01List = [...state.SYS3050_R01List];
		_SYS3050_R01List[index] = data;
		return { ...state, SYS3050_R01List: _SYS3050_R01List };
	}),

	//그리드 삭제작업예정 지정
	removeSYS3050_R01List: (empNo: string) => set((state) => {
		const _SYS3050_R01List = [...state.SYS3050_R01List];
		_SYS3050_R01List.splice(_SYS3050_R01List.findIndex(value => value.empNo === empNo), 1);
		return { ...state, SYS3050_R01List: _SYS3050_R01List };
	}),

	//그리드 컬럼 구성 순서 상태 지정정
	columnState: null,		setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	initData: () => set((state) => ({
		...state,
		SYS3050_R01Filter: defaultSYS3050_R01Filter,
		SYS3050_R01PastFilter: defaultSYS3050_R01Filter,
		SYS3050_R01List: [],
		editSYS3050_R01: defaultSYS3050_R01Dto,
		selectedSYS3050_R01: undefined,
		allCount: 0,
		scrollTop: null,
	})),

}))

export default useSYS3050_R01Store;